define(['jQuery', 'clientComponents/deviceinfo/deviceInfo'], function ($, deviceInfo) {
    'use strict';

    let backdrop = '.navbar-menu-backdrop';
    let toggle = '[data-toggle="navbar-menu"]';
    let NavbarMenu = function (element) {
        $(element).on('click.navbar-menu', this.toggle);
    };

    NavbarMenu.VERSION = '1.0.0';

    function getParent($this) {
        let selector = $this.attr('data-target');

        if (!selector) {
            selector = $this.attr('href');
            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
        }

        let $parent = selector && $(selector);

        return $parent && $parent.length ? $parent : $this.parent();
    }

    function clearMenus(e) {
        if (e && e.which === 3) {
            return;
        }

        if (e && typeof e.type !== 'undefined') {
            if ($(e.target).parents('.cms').length || $(e.target).hasClass('cms') || $(e.target).hasClass('modal-backdrop')){
                return;
            }
            if (e.type === 'mouseover') {
                if($(e.target).parents('[data-fcse-role="navbar-container"]').length) {
                    return;
                }
            }
        }

        $(backdrop).remove();
        $(toggle).each(function () {
            let $this = $(this);
            let $parent = getParent($this);
            let relatedTarget = {relatedTarget: this};

            if (!$parent.hasClass('open')) {
                return;
            }

            if (e && e.type === 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) {
                return;
            }

            $parent.trigger(e = $.Event('hide.navbar-menu', relatedTarget));

            if (e.isDefaultPrevented()) {
                return;
            }

            $this.attr('aria-expanded', 'false');
            $this.toggleClass('open');
            $parent.removeClass('open').trigger('hidden.navbar-menu', relatedTarget);
        })
    }

    NavbarMenu.prototype.toggle = function (e) {
        let $this = $(this);
        if ($this.is('.disabled, :disabled')) {
            return;
        }

        if (deviceInfo.isTouching && e.type === 'mouseover') {
            return;
        }

        let $parent = getParent($this);
        let isActive = $parent.hasClass('open');

        clearMenus();

        if (!isActive) {
            if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
                $(document.createElement('div'))
                    .addClass('navbar-menu-backdrop')
                    .insertAfter($(this))
                    .on('click', clearMenus)
            }

            $this
                .trigger('focus')
                .attr('aria-expanded', 'true');

            $this.toggleClass('open');
            $parent.toggleClass('open');
        }

        if (e.type === 'click') {
            if (deviceInfo.isTouching) {
                if ($this.hasClass('touch-opened')) {
                    $this.removeClass('touch-opened');
                    $this.trigger('follow.navbar-menu');
                } else {
                    $(toggle).removeClass('touch-opened');
                    $this.addClass('touch-opened');
                }
            } else {
                $this.trigger('follow.navbar-menu');
            }
        }

        return false
    };

    function Plugin(option) {
        return this.each(function () {
            let $this = $(this);
            let data = $this.data('navbar-menu');

            if (!data) {
                $this.data('navbar-menu', (data = new NavbarMenu(this)));
            }
            if (typeof option === 'string') {
                data[option].call($this);
            }
        })
    }

    let old = $.fn.navbarMenu;

    $.fn.navbarMenu = Plugin;
    $.fn.navbarMenu.Constructor = NavbarMenu;

    $.fn.navbarMenu.noConflict = function () {
        $.fn.navbarMenu = old;
        return this
    };

    $(document)
        .on('click.navbar-menu.data-api', clearMenus)
        .on('mouseover.navbar-menu.data-api', 'html,body', clearMenus)
        .on('mouseover.navbar-menu.data-api', toggle + ':not(.open)', NavbarMenu.prototype.toggle)
        .on('click.navbar-menu.data-api', toggle, NavbarMenu.prototype.toggle)
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/navbarmenu/NavbarMenu.js